<template>
  <button
    type="button"
    class="user-menu-trigger flex items-center gap-2 bg-transparent border border-gray-200 rounded-full pl-1 pr-2 py-1 cursor-pointer"
    :aria-label="ariaLabel"
    aria-haspopup="menu"
    v-bind="$attrs"
  >
    <Avatar :user="user || undefined" size="sm" :ring="false" />
    <span v-if="showName" class="font-medium text-sm leading-tight text-left max-w-32 truncate">{{ displayName }}</span>
    <i class="fa-solid fa-angle-down text-xs text-gray-500" aria-hidden="true"></i>
  </button>
</template>

<script setup>
import { computed } from 'vue'
import Avatar from '@/components/common/Avatar.vue'
import { useUserStore } from '@/stores/user'

const props = defineProps({
  showName: {
    type: Boolean,
    default: true,
  },
  ariaLabel: {
    type: String,
    default: 'User menu',
  },
})

const userStore = useUserStore()
const user = computed(() => userStore.getUser)

const displayName = computed(() => {
  const u = user.value
  if (!u) return ''
  const composed = `${u.first_name || ''} ${u.last_name || ''}`.trim()
  return u.display_name || composed || u.username || ''
})
</script>

<style scoped>
.user-menu-trigger {
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.user-menu-trigger:hover {
  background-color: var(--p-gray-50);
  border-color: var(--p-gray-300);
}
</style>
